import React from "react";
import AnimationPlayer from "../Animation-Player/AnimationPlayer";
import VybogTALLoader from "../../Assets/Json/VybogTAL-Loader.json";

function VybogTALLoaderAnimation({
  animationHeight = "150px",
  animationWidth = "150px",
}) {
  return (
    <div>
      <AnimationPlayer
        animationSrc={VybogTALLoader}
        playerHeight={animationHeight}
        playerWidth={animationWidth}
      />
    </div>
  );
}

export default VybogTALLoaderAnimation;
